/**
 Format a value to a fixed number of digits.
 @param {NumberWidget} value - The value.
 @param {NumberWidget} [digits=3] - The number of digits.
 @return {String} The formatted value.
 **/
function toDigits(value, digits = 3) {
  const asFloat = parseFloat(value);
  const changes = Math.floor(Math.log(Math.abs(asFloat)) * Math.LOG10E);

  if (changes < 0) {
    return asFloat.toFixed(digits - 1);
  }
  if (changes >= digits) {
    return `${Math.round(asFloat)}`;
  }
  return asFloat.toPrecision(digits);
}

/**
 Format a byte value with standard units and a fixed number of digits.
 @param {NumberWidget} value - The value.
 @param {NumberWidget} [digits=3] - The number of digits to display.
 @param {NumberWidget} [binary=false] - If true, calculations will use powers of two.
 @return {String} The formatted value.
 **/
function formatUnits(value, digits = 3, binary = false) {
  const base = binary
    ? 1024
    : 1000;
  const names = binary
    ? ['', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB']
    : ['', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const asFloat = parseFloat(value);
  const changes = Math.floor(Math.log(Math.abs(value)) / Math.log(base));

  if (value >= 0 && value < 1) {
    return toDigits(asFloat, digits);
  }
  return `${toDigits(asFloat / (base ** changes), digits)} ${names[changes]}`;
}

export default formatUnits;
